import { queryOptions } from "@tanstack/react-query";
import { apiClient } from "@/lib/api";
import { publicPath } from "@/lib/branch";
import { publicHomePageSchema } from "../schemas/home.schemas";

export const homeKeys = {
  all: ["home"] as const,
  content: () => [...homeKeys.all, "content"] as const,
};

/**
 * What the salon wrote for its landing page (TDD-SA FR-SA-191). Re-read when the customer comes back
 * to the tab, at most once a minute, as the profile is: the salon admin edits it and expects an open
 * page to follow. On a branch's site it is that branch's page: its own pictures once the salon gave it
 * some (FR-SA-262).
 */
export const homeContentQuery = () =>
  queryOptions({
    queryKey: homeKeys.content(),
    queryFn: () => apiClient.get(publicHomePageSchema, publicPath("/home")),
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  });
